import { useQuery } from '@tanstack/react-query';
import { api } from './api';
import type { PortalContactData } from '@/types/api';

/** Read-only list of the client's own team/contacts. */
export function usePortalContacts() {
  return useQuery({
    queryKey: ['portal-contacts'],
    queryFn: async (): Promise<PortalContactData[]> => {
      const { data } = await api.get<PortalContactData[]>('/v1/portal/contacts');
      return data;
    },
  });
}
